const cssCityReducer = (state = '', action) => {
	switch(action.type){
	case 'CSSCITYVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default cssCityReducer;